import React from "react";

const formatNum = (n) =>
  Number(n || 0).toLocaleString("en-PK", { maximumFractionDigits: 0 });

const CustomerItemSummaryCards = ({ rows = [], onPriceChange }) => {
  if (!rows?.length) {
    return (
      <p className="text-center text-muted text-sm py-6">No items found.</p>
    );
  }

  return (
    <div className="flex flex-col gap-2 w-full">
      {rows.map((item, index) => {
        const isTotal = item.name === "Total";
        return (
          <div
            key={`${item.name}-${item.type || ""}-${index}`}
            className={`rounded-lg border px-3 py-2.5 ${
              isTotal
                ? "bg-main text-white border-main shadow-soft"
                : "bg-card border-line shadow-soft"
            }`}
          >
            <div className="flex items-start justify-between gap-2">
              <div className="min-w-0 flex-1">
                <p
                  className={`text-sm font-bold truncate ${
                    isTotal ? "text-white" : "text-ink"
                  }`}
                >
                  {item.name}
                </p>
                {!isTotal && (
                  <p className="text-[10px] text-muted mt-0.5 uppercase">
                    Unit: {item.type || "—"}
                  </p>
                )}
              </div>
              <p
                className={`text-sm font-extrabold tabular-nums shrink-0 ${
                  isTotal ? "text-white" : "text-main"
                }`}
              >
                {formatNum(item.amount)}
              </p>
            </div>

            {!isTotal && (
              <div className="mt-2 pt-2 border-t border-line grid grid-cols-2 gap-2 text-[11px]">
                <div>
                  <span className="text-muted block text-[10px]">Price</span>
                  <input
                    type="number"
                    value={item.price}
                    onChange={(e) =>
                      onPriceChange?.(item, Number(e.target.value))
                    }
                    className="w-full mt-0.5 px-2 py-1 rounded border border-line text-ink font-semibold tabular-nums"
                  />
                </div>
                <div>
                  <span className="text-muted block text-[10px]">Qty</span>
                  <p className="mt-1 font-semibold text-ink tabular-nums">
                    {formatNum(item.qty)}
                  </p>
                </div>
              </div>
            )}

            {isTotal && (
              <div className="mt-2 flex justify-between text-xs text-white/90">
                <span>Total qty</span>
                <span className="font-bold tabular-nums">{formatNum(item.qty)}</span>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default CustomerItemSummaryCards;
